import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'

import '@/assets/css/style.css'
import '@/assets/js/lib.js'
import axios from "axios"

import Element from "element-ui"
import "element-ui/lib/theme-chalk/index.css"
// 当前环境
Vue.prototype.$env = process.env.NODE_ENV

Vue.config.productionTip = false

Vue.use(Element);

router.beforeEach((to, from, next)=>{
  if(to.meta.title){
    document.title = to.meta.title
  }
  next()
})

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
